import { useContext } from "react";
import { Context } from "../../utils/main-context/MainContext";

import "./about.scss";

import about from "../../database/about.json";

import ExpressJS from "../../assets/images/about/expressjs.png";
import JS from "../../assets/images/about/js.png";
import nodeJS from "../../assets/images/about/nodejs.png";
import ReactJS from "../../assets/images/about/reactjs.png";
import Sass from "../../assets/images/about/sass.png";
import Tailwind from "../../assets/images/about/tailwindcss.png";
import monogoDB from "../../assets/images/about/mongodb.png";
import typescript from "../../assets/images/about/typescript.png";
import nextJS from "../../assets/images/about/next-js.svg";

const About = () => {
  const { aboutActive } = useContext(Context);

  return (
    <section id="about" className={aboutActive ? "about active" : "about"}>
      <div className="container">
        <p className="summary">{about.about.description}</p>
        <ul className="technologies-list">
          <li className="technologies-item">
            <img src={Sass} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={Tailwind} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={JS} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={ReactJS} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={ExpressJS} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={nodeJS} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={monogoDB} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={typescript} alt="#" />
          </li>
          <li className="technologies-item">
            <img src={nextJS} alt="#" />
          </li>
        </ul>
      </div>
    </section>
  );
};

export default About;
